import { FC, useState } from 'react';
import { CustomDateRangePicker, DropdownWithSearch } from 'components';
import { defaultStaticRanges } from 'react-date-range';
import DateUtils from 'utils/dateUtils';
import { PAY_RUN_STATUS_OPTIONS } from '../constants';

interface PayRunsFilterProps {
  status: string[];
  setStatus: (status: string[]) => void;
  payPeriodFrom: string | null;
  setPayPeriodFrom: (date: string | null) => void;
  payPeriodTo: string | null;
  setPayPeriodTo: (date: string | null) => void;
}

const PayRunsFilter: FC<PayRunsFilterProps> = ({
  status,
  setStatus,
  payPeriodFrom,
  setPayPeriodFrom,
  payPeriodTo,
  setPayPeriodTo
}) => {
  const [statusDraft, setStatusDraft] = useState<string[]>([]);
  const currentDate = new Date();

  const checkCustomFieldSelected = () => false;

  const payPeriodDateRanges = [
    {
      label: 'Today',
      isSelected: checkCustomFieldSelected,
      range: () => ({
        startDate: currentDate,
        endDate: currentDate
      })
    },
    ...defaultStaticRanges.filter(range => range.label !== 'Today' && range.label !== 'Yesterday'),
    {
      label: 'This year',
      isSelected: checkCustomFieldSelected,
      range: () => ({
        startDate: DateUtils.getStartOfYear(currentDate.getFullYear()),
        endDate: DateUtils.getEndOfYear(currentDate.getFullYear())
      })
    },
    {
      label: 'Last year',
      isSelected: checkCustomFieldSelected,
      range: () => ({
        startDate: DateUtils.getStartOfYear(currentDate.getFullYear() - 1),
        endDate: DateUtils.getEndOfYear(currentDate.getFullYear() - 1)
      })
    }
  ];

  const setDateRange = (updatedStartDate: string | null, updatedEndDate: string | null) => {
    setPayPeriodFrom(updatedStartDate);
    setPayPeriodTo(updatedEndDate);
  };

  const getStatusFilterText = () => {
    return PAY_RUN_STATUS_OPTIONS.filter(item => status.includes(item.value))
      .map(item => item.label)
      .join(', ');
  };

  return (
    <div className="flex gap-4">
      <DropdownWithSearch
        filterId="pay-runs-status-filter"
        data={PAY_RUN_STATUS_OPTIONS}
        selectedDraftArray={statusDraft}
        setSelectedDraftArray={setStatusDraft}
        selectedArray={status}
        setSelectedArray={setStatus}
        dataKey="label"
        dataIdKey="value"
        buttonPrimaryText="Status"
        buttonSecondaryText={getStatusFilterText()}
        filterPlaceholderText="Filter by status"
        allowSearch={false}
        filterPlaceholderStyle="font-semibold"
        searchInputStyle="placeholder:text-primaryText"
      />

      <CustomDateRangePicker
        filterId="pay-period-filter"
        startDate={payPeriodFrom}
        setStartDate={setPayPeriodFrom}
        endDate={payPeriodTo}
        setEndDate={setPayPeriodTo}
        hasDefaultRanges={false}
        placeholder="Pay period"
        customRanges={payPeriodDateRanges}
        setDateRange={setDateRange}
      />
    </div>
  );
};

export default PayRunsFilter;
